import {
	ResponsiveContainer,
	ComposedChart,
	XAxis,
	YAxis,
	Bar,
	Line,
	LabelList,
	Tooltip,
	BarChart,
	Legend,
	Cell, Pie, PieChart, 
} from "recharts";
import { Container, Content } from "rsuite";
import { useRef, useState } from "react";
import { numberFormatter } from "../../utils";

interface Props {
	chartData: any;
    pieChartData:any;
    lineChartData:any;
    legendData:any;
    chartTableData:any;
    selectedL4:any;
    updateSelectedL4:any;
    selectedDistrict:any;
    handleTabChange:any;
    page:any;
    detailViewType:any;
    updatePopUp:any;
}

interface T {
	quarter: string;
	actual: number;
	forecastedSpend: number;
	spendNeededForNextTier: number;
	spendShift: number;
	targetGrowthSpend: number;
}

const SupplierChart = (props: Props) => {
	
	const {chartTableData, chartData, pieChartData, lineChartData, page, selectedL4, legendData, detailViewType, updatePopUp}=props
    let pieChartDataLY = [
      { name: 'Tail Suppliers', value: pieChartData.LYNonPreferred },
      { name: 'Strategic Suppliers', value: pieChartData.LYPreferred },
    ];

    let pieChartDataCY = [
      { name: 'Tail Suppliers', value: pieChartData.CYNonPreferred },
      { name: 'Strategic Suppliers', value: (pieChartData.CYPreferred - pieChartData.LYPreferred)>0 ? (pieChartData.CYPreferred - (pieChartData.CYPreferred - pieChartData.LYPreferred)) : pieChartData.CYPreferred},
    ];
    if ((pieChartData.CYPreferred - pieChartData.LYPreferred) > 0) {
      pieChartDataCY.push({
        name: "Incremental",
        value: (pieChartData.CYPreferred - pieChartData.LYPreferred),
      });
    }
   
    const RADIAN = Math.PI / 180;
    const COLORS = ['#dfdfdf', '#149cac', '#8cbd35'];

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
      const y = cy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

      return (
        <text x={x+5} y={y} fill="black" fontSize={'1.7vh'} fontWeight={'500'} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          {((percent ?? 1) * 100) < 10 ? `` :`${((percent ?? 1) * 100).toFixed(0)}%`}
        </text>
      );
    };
	const points = [25, 50, 75, 100];

	const [tooltip, setTooltip] = useState<any>({
		l4: "",
		show: false,
		vendorSpendPrcnt: 0,
		master_vendor_name: "",
	});

	const onHover = (data: any, index: number) => {
		setTooltip({
			show: true,
			l4: data.payload.l4,
			vendorSpendPrcnt: data.value,
			master_vendor_name: data.dataKey,
		});
	};

	const onOut = () => {
		setTooltip({ show: false, l4: "", vendorSpendPrcnt: "" });
	};

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;
			return (
				<div className="custom-tooltip">
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
								color: "#C8C8C8",
								fontSize: "10px",
								fontWeight: "normal",
							}}
						>
							Month :{" "}
						</label>
						<label
							style={{
								color: "#EAEAEA",
								fontSize: "10px",
								fontWeight: "bold",
							}}
						>
							{data.Month}
						</label>
					</p>
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
							color: "#C8C8C8",
							fontSize: "10px",
							fontWeight: "normal",
							}}
						>
							Gross Margin :{" "}
						</label>
						<label
							style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}
						>
							{Number(data?.gm)?.toFixed(2)}%
						</label>
					</p>
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
							color: "#C8C8C8",
							fontSize: "10px",
							fontWeight: "normal",
							}}
						>
							Wallet Share :{" "}
						</label>
						<label
							style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}
						>
							{Number(data?.walletShare)?.toFixed(2)}%
						</label>
					</p>
				</div>
			);
		}
	};

	 const customTooltip1 = ({ active, payload }: any) => {
      if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
          <div className="custom-tooltip">
            <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "#C8C8C8",
                  fontSize: "12px",
                  fontWeight: "normal",
                }}
              >
                {data.name}:{' '}
              </label>
              <label
                style={{ color: "#EAEAEA", fontSize: "12px", fontWeight: "bold" }}
              >
                {(Number(data.value ) * 100)?.toFixed(2)}%
              </label>
            </p>
            
          </div>
        );
      }
    };
  

	return (
		<>
			{/* <div className="common-table-header-row">
				<span className="common-table-header">
					{" "}
					Supplier spend % with L4 categories in{" "}
					{props.selectedDistrict}
				</span>
				<div className="buttonWrapper flex">
					{page == "overview" ? (
						<button
							className="savingButton"
							onClick={() => {
								props.handleTabChange("details");
							}}
						>
							Go to Details
						</button>
					) : (
						<button
							className="savingButton"
							onClick={() => {
								props.handleTabChange("overview");
							}}
						>
							Go to Overview
						</button>
					)}
				</div>
			</div>

			<table className="common-table-ui w-full">
				<thead>
					<tr>
						<th className=" min-w-[5vw] max-w-full !border-b-0"></th>
						{chartData?.map((d: any, index: any) => {
							return (
								<td className="bg-white ">
									<ResponsiveContainer
										width="100%"
										height="100%"
										minHeight={"10vw"}
										key={d?.l4}
										style={{
											marginBottom: "-2.3vh",
											marginLeft: "1vw",
										}}
									>
										<BarChart
											data={[d]}
											layout="horizontal"
											stackOffset="expand"
										>
											<XAxis
												hide
												type="category"
												dataKey="l4"
											/>
											<YAxis hide type="number" />

											{d.data.map(
												(vendor: any, ind: number) => {
													return (
														<Bar
															key={
																vendor?.master_vendor_name
															}
															dataKey={
																vendor?.master_vendor_name
															}
															stackId="a"
															onMouseEnter={(
																a: any,
																index
															) =>
																onHover(
																	a
																		.tooltipPayload[0],
																	index
																)
															}
															onMouseLeave={onOut}
															fill={
																vendor?.vendorColor
															}
															barSize={70}
														>
															{Number(
																vendor?.vendorSpendPrcnt
															) > 12 && (
																<LabelList
																	dataKey={
																		vendor?.master_vendor_name
																	}
																	fill="black"
																	fontWeight={
																		700
																	}
																	className="graph-label"
																	formatter={(
																		value: number
																	) =>
																		value ==
																		0
																			? null
																			: `${numberFormatter(
																					value,
																					0
																			  )}%`
																	}
																	position="center"
																></LabelList>
															)}
														</Bar>
													);
												}
											)}
										</BarChart>
									</ResponsiveContainer>
									{tooltip.show && tooltip.l4 == d.l4 && (
										<div
											className="flex flex-col items-start absolute bg-[#353535] p-[1vh] pointer  z-[99]"
											style={{
												width: "fit-content",
												background: "white",
												border: "1px solid #ccc",
												boxShadow:
													"0 2px 5px rgba(0,0,0,0.2)",
												borderRadius: "1vh",
												color: "black",
											}}
										>
											<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
												<div className="font-bold uppercase">
													Supplier:{" "}
												</div>
												<div
													className="font-bold ml-1"
													style={{ color: "#3f3f3f" }}
												>
													{tooltip.master_vendor_name}
												</div>
											</div>
											<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
												<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Spend (%):{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														{tooltip.vendorSpendPrcnt.toFixed(
															2
														)}
													</label>
												</p>
											</div>
										</div>
									)}
								</td>
							);
						})}
					</tr>
					<tr className="graphTable">
						<th
							className="min-w-[5vw] max-w-full"
							style={{
								color: "black",
								border: "1px dashed white",
								borderTop: 0,
								borderLeft: 0,
							}}
						></th>
						{chartTableData?.map((value: any, index: any) => {
							return (
								<th
									className={`  min-w-[5vw] max-w-full`}
									style={{
										color: "black",
										border: "1px dashed white",
										cursor: "pointer",
										borderTop: "2px solid white",
										backgroundColor: `${
											selectedL4 == value?.l4 &&
											selectedL4 !== null
												? "#e6ffc8f0"
												: ""
										}`,
										// color:`${selectedL4 ==
										//   value?.l4 && selectedL4 !== null
										//   ? "black"
										//   : "white"}`
									}}
									onClick={() => {
										props.updateSelectedL4(value?.l4);
									}}
								>
									{value?.l4}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody
					style={{
						border: "1px solid #bebebe",
						alignItems: "center",
						height: "max-content",
					}}
					className=""
				>
					<tr
						style={{
							border: "1px solid #bebebe",
							alignItems: "center",
							height: "max-content",
						}}
					>
						<td style={{ padding: "0.5vw" }} className="center">
							Spend
						</td>
						{chartTableData?.map((value: any) => {
							return (
								<td>
									{numberFormatter(
										value?.l4MatGrpSpend,
										1,
										"$"
									)}
								</td>
							);
						})}
					</tr>
					<tr
						style={{
							border: "1px solid #bebebe",
							alignItems: "center",
							height: "max-content",
						}}
					>
						<td style={{ padding: "0.5vw" }} className="center">
							Spend % with Sub Optimal Margin
						</td>
						{chartTableData?.map((value: any) => {
							return (
								<td>
									{numberFormatter(
										value?.spendPrcntNonOptimal,
										0
									)}
									%
								</td>
							);
						})}
					</tr>
					<tr
						style={{
							border: "1px solid #bebebe",
							alignItems: "center",
							height: "max-content",
						}}
					>
						<td style={{ padding: "0.5vw" }} className="center">
							Preferred supplier & GM
						</td>
						{chartTableData?.map((value: any) => {
							return (
								<td>
									<span>{value?.preferredSupplier}</span>
									<br />
									<span>
										(
										{numberFormatter(
											value?.marginPSYTD * 100,
											0
										)}
										%)
									</span>
								</td>
							);
						})}
					</tr>
					<tr
						style={{
							border: "1px solid #bebebe",
							alignItems: "center",
							height: "max-content",
						}}
					>
						<td style={{ padding: "0.5vw" }} className="center">
							Avg Gross Margin
						</td>
						{chartTableData?.map((value: any) => {
							return (
								<td>
									{numberFormatter(
										value?.avgGrossMarginPrcnt,
										0
									)}
									%
								</td>
							);
						})}
					</tr>
					<tr
						style={{
							border: "1px solid #bebebe",
							alignItems: "center",
							height: "max-content",
						}}
					>
						<td style={{ padding: "0.5vw" }} className="center">
							Lost Opportunity
						</td>
						{chartTableData?.map((value: any) => {
							return (
								<td>
									{numberFormatter(
										value?.lostOpportunity,
										1,
										"$"
									)}
								</td>
							);
						})}
					</tr>
				</tbody>
			</table>
			<div className=" contentFooter flex gap-x-[2vh] text-[1.5vh] justify-end pt-[1vh] px-[2vh] text-black">
				{Object.keys(legendData).map((item: any) => {
					return (
						<div className="flex gap-x-[.7vh]">
							<div
								className={"w-[2vh] h-[2vh]"}
								style={{ background: legendData[item] }}
							/>
							{item}
						</div>
					);
				})}
			</div> */}
			 <div className={`w-full ${page=='overview'? 'h-[60vh]' : 'h-[55vh]'}`}>
        <div className="bg-[#646464]">
          <p className="text-center italic font-semibold text-white text-0.95vw">
            { page == "details" && detailViewType == 'marginTrend'?
           ` Strategic Supplier spend % & Margin in ${props.selectedDistrict}`:
            `Supplier spend % with L4 categories in ${props.selectedDistrict}`
            }
          </p>
        </div>

        <div className="max-h-full h-[90%] overflow-y-auto mt-[.5vh]">

         { page == "details" && detailViewType == 'l4Level' && <div className="flex gap-x-[2vh] bg-white text-[1.5vh] justify-end pt-[1vh] px-[2vh]">
            {Object.keys(legendData).map((item:any)=>{
              return(
                <div className="flex gap-x-[.7vh] text-black">
                  <div className={"w-[2vh] h-[2vh]"} style={{background: legendData[item]}} />
                  {item}
                </div>
              )
            })}
          </div>}

            {
              page =="overview" &&
              <div className="pt-[1vh] pl-[1vh] absolute z-[1000]">
                <button className="text-[0.7vw] bg-[#939495] px-2 py-1 rounded-md"
                  onClick={()=>{
                  updatePopUp(true);
                  }}
                  >
                Select Strategic Suppliers
                </button>
              </div>
            }
          <div className={`${ (page == "overview" || detailViewType != 'marginTrend') ? 'h-[0]' :'h-[45%]'}`}>
            
         {
          //  page == "overview"?
            
          //   <ResponsiveContainer width="100%" height="85%">
          //   <PieChart width={400} height={400}>
          //     <Pie
          //       data={data}
          //       cx="30%"
          //       cy="50%"
          //       labelLine={false}
          //       label={renderCustomizedLabel}
          //       outerRadius={80}
          //       fill="#8884d8"
          //       dataKey="value"
          //     >
          //       {data.map((entry, index) => (
          //         <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
          //       ))}
          //     </Pie>
          //      <Pie
          //       data={data}
          //       cx="70%"
          //       cy="50%"
          //       labelLine={false}
          //       label={renderCustomizedLabel}
          //       outerRadius={80}
          //       fill="#8884d8"
          //       dataKey="value"
          //     >
          //       {data.map((entry, index) => (
          //         <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
          //       ))}
          //     </Pie>
          //   </PieChart>
          //   </ResponsiveContainer>
          //  :
           page =='details' && detailViewType == 'marginTrend' ? 
            
              <ResponsiveContainer width="100%" height="98%" className='bg-[#e4e4e4] p-[2vh] pt-[0]'>
                      <ComposedChart data={lineChartData} className='chartConatiner' margin={{ top: 20 }}>
                        <XAxis dataKey="MonthName" stroke="black" fontSize="1.5vh" >
                            
                        </XAxis>
                        <YAxis
                          stroke="black"
                          fontSize="1.5vh"
                          tickFormatter={(value: number) => numberFormatter(value, 0, "$")}
                          // domain={['dataMin - 10000000', 'dataMax + 10000000']}
                         
                        >
                          
                        </YAxis>
                       
                        <Tooltip
                          contentStyle={{
                            color: "white",
                            backgroundColor: "rgb(26, 25, 22)",
                          }}
                          cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
                          content={customTooltip}
                        />
                        <Legend  wrapperStyle={{ margin: '-1vh' }}/>
                       
                        <Line
                          type="linear"
                          dataKey="gm"
                          name={`Gross Margin`}
                          stroke="#153272"
                          strokeDasharray={"0"}
                          connectNulls={false}
                          strokeWidth={3}
                        />
                         <Line
                          type="linear"
                          dataKey="walletShare"
                          // legendType="none"
                          stroke="#14aeae"
                          name={`Wallet Share %`}
                          strokeDasharray={"0"}
                          connectNulls={true}
                          strokeWidth={3}
                        />
                       
                       
                      </ComposedChart>
                    </ResponsiveContainer>
            
            : <></>
          }
          
          </div>
        
          <table className="supplierConsolidationTable graphTable">
            <thead>
            <tr>
               { page == "details" && detailViewType == 'l4Level' &&
               <>
                <th className="w-[5vw] max-w-[5vw] min-w-[5vw]" style={{background:'white', border:0, padding:0, paddingTop:'1vh'}}>
                    <Container>
                      <Content>
                        <div style={{ position: 'relative', height: '23.1vh', width: '100%', display:'flex', justifyContent:'flex-end', fontSize:'1.4vh', fontWeight:'400'}}>
                          <div style={{ position: 'absolute', left: '100%', transform: 'translateX(-50%)', height: '100%', borderLeft: '2px solid black' }}>
                            {points.map(point => (
                              <div key={point} style={{ position: 'absolute', bottom: `${((point / 100) * 100)-10}%`, left: '-4vh', width: '20px', textAlign: 'left', color:'black' }}>
                                {point}%
                              </div>
                            ))}
                          </div>
                          <div style={{writingMode:'sideways-lr', position:'relative' ,left:'-5vh', color:'black' }}>Spend %</div>
                        </div>
                      </Content>
                    </Container>
                </th>
                {chartData?.map((d:any, index:any)=>{
                  return(
                   <td className="bg-white">
                     <ResponsiveContainer
                      width="100%"
                      height="100%"
                      minHeight={"10vw"}
                      key={d?.l4}
                      style={{marginBottom:'-2.3vh'}}
                    >
                      <BarChart data={[d]} layout="horizontal" stackOffset="expand" >
                        <XAxis hide type="category" dataKey="l4" />
                        <YAxis hide type="number" />
            
                        {d.data.map((vendor: any, ind: number) => {
                          return (
                            <Bar
                              key={vendor?.master_vendor_name}
                              dataKey={vendor?.master_vendor_name}
                              stackId="a"
                              onMouseEnter={(a: any, index) =>
                                onHover(
                                  a.tooltipPayload[0],
                                  index
                                )
                              }
                              onMouseLeave={onOut}
                              fill={vendor?.vendorColor}
                              barSize={30}
                            >
                            {
                            Number(vendor?.vendorSpendPrcnt) > 12 && <LabelList
                              dataKey={vendor?.master_vendor_name}
                              fill="black"
                              fontWeight={700}
                              fontSize="1.2vh"
                              formatter={(value: number) =>
                                value == 0 ? null : `${numberFormatter(value, 0)}%`
                              }
                              position="center"
                            ></LabelList>}
                            </Bar>
                          );
                        })}
                      </BarChart>
                    </ResponsiveContainer>
                    {tooltip.show && tooltip.l4 == d.l4 && <div className="flex flex-col items-start absolute bg-[#353535] p-[1vh] pointer opacity-90 z-[99]">
                  <span className="text-[#C8C8C8] font-normal">Supplier: <span className="text-[#EAEAEA] font-bold">{tooltip.master_vendor_name}</span></span>
                  <span className="text-[#C8C8C8] font-normal">Spend (%): <span className="text-[#EAEAEA] font-bold">{tooltip.vendorSpendPrcnt.toFixed(2)}</span></span>
                </div>}
                   </td>
                  )
                })}
                </> 
                }
              {
                page == "overview" &&
                <>
                {/* <th className="w-[5vw] max-w-[5vw] min-w-[5vw]" style={{background:'#4d4d4d', border:0, padding:0, paddingTop:'1vh'}}>

                </th> */}
                <td className="bg-white">

                 <ul style={{ listStyleType: 'none', padding: 0, paddingLeft:'1vh', columnGap:'2vh' }}>
                    
                      <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4, color:'black',
                      fontSize: '1.5vh' 
                      }}>
                     
                        <div style={{ width: 10, height: 10, backgroundColor: '#149cac', marginRight: 8 }}></div>
                        Strategic Suppliers
                      </li>
                      <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4, color:'black',
                     fontSize: '1.5vh' 
                      }}>
                     
                        <div style={{ width: 10, height: 10, backgroundColor: '#dfdfdf', marginRight: 8 }}></div>
                        Tail Suppliers
                      </li>
                       <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4, color:'black',
                      fontSize: '1.5vh' 
                      }}>
                     
                        <div style={{ width: 10, height: 10, backgroundColor: '#8cbd35', marginRight: 8 }}></div>
                        Incremental
                      </li>
                    
                  </ul>

                </td>
                <td className="flex items-center bg-white justify-center">
                  <ResponsiveContainer  width="100%"
                      height="100%"
                      minHeight={"14vw"}
                      style={{marginBottom:'-2.3vh'}}>
                    <PieChart width={400} height={40}>
                      <Pie
                        data={pieChartDataLY}
                        cx="30%"
                        cy="50%"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={70}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {pieChartDataLY.map((entry, index) => (
                          <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                       <Tooltip 
                        contentStyle={{
                          color: "black",
                          backgroundColor: "rgb(247, 247, 247)",
                        }}
                        cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
                        content={customTooltip1}
                       />
                    </PieChart>
                  </ResponsiveContainer>
                </td>
                <td className="bg-white">
                  <ResponsiveContainer width="100%"  height="100%"
                      minHeight={"12vw"}
                      style={{marginBottom:'-2.3vh', paddingLeft:'2vh'}}>
                    <PieChart width={400} height={40}>
                      <Pie
                        data={pieChartDataCY}
                        cx="30%"
                        cy="50%"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={70}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {pieChartDataCY.map((entry, index) => (
                          <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                       <Tooltip 
                        contentStyle={{
                          color: "black",
                          backgroundColor: "rgb(247, 247, 247)",
                        }}
                        cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
                        content={customTooltip1}
                       />
                    </PieChart>
                  </ResponsiveContainer>
                </td>
                </>
              }
               
              </tr>
              <tr>
                {
                  (page == "details" && detailViewType == 'l4Level') ?
                <>
                <th className="w-[5vw] max-w-[5vw] min-w-[5vw]" style={{background:'white', border:'1px dashed black', borderTop:0, borderLeft:0}}></th>
                { chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any, index:any)=>{
                  return(
                    <th 
                    className={`w-[5vw] max-w-[5vw] min-w-[5vw]`}
                     style={{background:'white', 
                      border:'1px dashed black', 
                      cursor:'pointer', 
                      borderTop:'2px solid black',
                      backgroundColor:`${selectedL4 ==
                        value?.l4 && selectedL4 !== null
                        ? "#e6ffc8f0"
                        : "#e6ffc8f0"}`,
                      color:`${selectedL4 ==
                        value?.l4 && selectedL4 !== null
                        ? "black"
                        : "black"}`
                     }}
                    onClick={()=>{
                      props.updateSelectedL4(value?.l4);
                    }}
                    >{value?.l4}</th>
                  )
                })}
                </>
                :
                <>
                <th className="w-[5vw] max-w-[5vw] min-w-[5vw]" style={{background:'white', border:'1px dashed black', borderTop:0, borderLeft:0}}></th>
                <th  className={`w-[5vw] max-w-[5vw] min-w-[5vw]`}
                     style={{background:'white', 
                      border:'1px dashed black', 
                      cursor:'pointer', 
                      backgroundColor: "white",
                      color: "black"
                     }} >2024 LYTD</th>
                <th className={`w-[5vw] max-w-[5vw] min-w-[5vw]`}
                     style={{background:'white', 
                      border:'1px dashed black', 
                      cursor:'pointer', 
                      backgroundColor: "white",
                      color: "black"
                     }}>2025 YTD</th>
                </>
              }
               
              </tr>
            </thead>
            <tbody>
              <tr style={{background: 'white'}}>
                <td className="center">Spend</td>
                { (page == "details" && detailViewType == 'l4Level') ?
                chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any)=>{
                  return(
                    <td>{numberFormatter(value?.l4MatGrpSpend, 1, "$")}</td>
                  )
                })
                : 
                <>
                <td> {chartTableData?.lastYear?.length>0 && numberFormatter(chartTableData?.lastYear[0]?.l4MatGrpSpend,1,"$")}</td>
                <td> {chartTableData?.currentYear?.length>0 && numberFormatter(chartTableData?.currentYear[0]?.l4MatGrpSpend,1,"$")}</td>
                </>
                }
              </tr>
              <tr style={{background: 'white'}}>
                <td className="center">Spend % with Sub Optimal Margin</td>
               { (page == "details" && detailViewType == 'l4Level') ?
              chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any)=>{
                  return(
                    <td>{numberFormatter(value?.spendPrcntNonOptimal,0)}%</td>
                  )
                })
                : 
                <>
                 <td> {chartTableData?.lastYear?.length>0 && numberFormatter(chartTableData?.lastYear[0]?.spendPrcntNonOptimal,1)}%</td>
                <td> {chartTableData?.currentYear?.length>0 && numberFormatter(chartTableData?.currentYear[0]?.spendPrcntNonOptimal)}%</td>
                </>
                }
              </tr>
              <tr style={{background: 'white'}}>
                <td className="center">Preferred supplier & GM</td>
               { (page == "details" && detailViewType == 'l4Level') ?
               chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any)=>{
                  return(
                    <td>
                      <span>
                        {value?.preferredSupplier}
                      </span>
                      <br />
                      <span>
                        ({numberFormatter(value?.marginPSYTD*100,0)}%)
                      </span>
                    </td>
                  )
                })
                :
                <>
                 <td> {chartTableData?.lastYear?.length>0 && `${chartTableData?.lastYear[0]?.preferredSupplier} (${numberFormatter(chartTableData?.lastYear[0]?.marginPSYTD*100,1)}%)`}</td>
                 <td> {chartTableData?.currentYear?.length>0 && `${chartTableData?.currentYear[0]?.preferredSupplier} (${numberFormatter(chartTableData?.currentYear[0]?.marginPSYTD*100,1)}%)`}</td>
                </>
                }
              </tr>
              <tr style={{background: 'white'}}>
                <td className="center">Avg Gross Margin</td>
                {
                  (page == "details" && detailViewType == 'l4Level') ?
               chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any)=>{
                  return(
                    <td>{numberFormatter(value?.avgGrossMarginPrcnt, 0)}%</td>
                  )
                })
                : 
                <>
                 <td> {chartTableData?.lastYear?.length>0 && numberFormatter(chartTableData?.lastYear[0]?.avgGrossMarginPrcnt,1)}%</td>
                <td> {chartTableData?.currentYear?.length>0 && numberFormatter(chartTableData?.currentYear[0]?.avgGrossMarginPrcnt,1)}%</td>
                </>
                }
              </tr>
              <tr style={{background: 'white'}}>
                <td className="center">Lost Opportunity</td>
               {
                (page == "details" && detailViewType == 'l4Level' ) ?
               chartTableData?.currentYear?.length>0 && chartTableData?.currentYear?.map((value:any)=>{
                  return(
                    <td>{numberFormatter(value?.lostOpportunity, 1, "$")}</td>
                  )
                })
                : 
                <>
                  <td> {chartTableData?.lastYear?.length>0 && numberFormatter(chartTableData?.lastYear[0]?.lostOpportunity,1,"$")}</td>
                  <td> {chartTableData?.currentYear?.length>0 && numberFormatter(chartTableData?.currentYear[0]?.lostOpportunity,1,"$")}</td>
                </>
                }
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-full flex justify-center">
           {
           page == "overview"?
           <button className="text-[0.7vw] bg-green-700 px-2 py-1 rounded-md"
            onClick={()=>{
              props.handleTabChange('details');
            }}
            >
            Go to Details
            </button>
            :
            <button className="text-[0.7vw] bg-green-700 px-2 py-1 rounded-md mt-[2vh]"
            onClick={()=>{
              props.handleTabChange('overview');
            }}
            >
            Go to Overview
            </button>}
        </div>
      </div>
		</>
	);
};

export default SupplierChart;
